<template>
  <div>
    <AdminMasterLayout>
      <div class="p-4 dashboard_first_row">
        <div class="dialog-container invoices_home">
          <div class="row">
            <div class="col-md-7">
              <h4 class="primary-color">{{ $t("text.cInvoice.title") }}</h4>
            </div>
          </div>
          <div class="invoice-banner mt-3">
            <div>
              <div>
                <span class="deep-grey bold-span invoice-header">{{
                  $t("text.cInvoice.overdue")
                }}</span>
              </div>
              <div class="">
                <span
                  ><span class="currency"></span
                  ><span class="amount-figures">{{ overDueAmount }}</span
                  ><span class="grey-text bold-span">{{
                    company ? company.currency : ""
                  }}</span></span
                >
              </div>
              <div class="grey-text">
                <span
                  ><small>{{ $t("text.cInvoice.last") }}</small>
                  <vue-moments-ago
                    prefix="updated"
                    suffix="ago"
                    :date="dateRetrieved"
                    lang="en"
                  ></vue-moments-ago
                ></span>
                <i
                  class="fa fa-refresh ml-1"
                  aria-hidden="true"
                  @click="getInvoices"
                  style="cursor: pointer; font-size: 13px"
                ></i>
              </div>
            </div>
            <div>
              <div>
                <span class="deep-grey bold-span invoice-header">{{
                  $t("text.cInvoice.due")
                }}</span>
              </div>
              <div>
                <span class="currency"></span
                ><span class="amount-figures">{{ dueInThirtyDays }}</span
                ><span class="grey-text bold-span">{{
                  company ? company.currency : ""
                }}</span>
              </div>
            </div>
          </div>
          <div class="mt-3">
            <form>
              <div class="row">
                <div class="col-md-2 padding-right-none">
                  <vue-ctk-date-time-picker
                    id="DateTimePicker1"
                    v-model="fromDate"
                    color="#370F70"
                    format="YYYY-MM-DDTHH:mm:ss"
                    formatted="DD/MM/YYYY"
                    position="bottom"
                    :onlyDate="true"
                    :autoClose="true"
                    :label="fromLabel"
                  />
                </div>
                <div class="col-md-4 padding-right-none">
                  <div class="row">
                    <div class="col-md-6 padding-right-none">
                      <vue-ctk-date-time-picker
                        id="DateTimePicker"
                        v-model="toDate"
                        color="#370F70"
                        format="YYYY-MM-DDTHH:mm:ss"
                        formatted="DD/MM/YYYY"
                        position="bottom"
                        :onlyDate="true"
                        :autoClose="true"
                        :label="toLabel"
                      />
                    </div>
                    <div class="col-md-6">
                      <select class="form-control mt-2" v-model="status">
                        <option selected value="allStatus">
                          {{ $t("text.cInvoice.allStatus") }}
                        </option>
                        <!-- <option value="3">OverDue</option> -->
                        <option value="4">
                          {{ $t("text.cInvoice.paid") }}
                        </option>
                        <option value="5">
                          {{ $t("text.cInvoice.partPaid") }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <input
                    type="text"
                    autofocus
                    class="mt-2 form-control"
                    placeholder="Enter invoice #"
                    v-model="invoiceNumber"
                  />
                </div>
              </div>
            </form>
          </div>
          <div class="mt-3">
            <div class="filter-menu">
              <div
                class="filter-item mr-3 text-center"
                @click="changeStatus('paid')"
                :class="[status === '4' ? 'activeFilter' : null]"
              >
                <span
                  class="mr-2"
                  :class="[status === '4' ? 'activeFilter' : null]"
                  >{{ $t("text.cInvoice.paid") }}</span
                >
                <span class="counter mr-2">{{ paidCount }}</span>
              </div>
              <div
                class="filter-item mr-3 text-center"
                @click="changeStatus('partPaid')"
                :class="[status === '5' ? 'activeFilter' : null]"
              >
                <span
                  class="mr-2"
                  :class="[status === '5' ? 'activeFilter' : null]"
                  >{{ $t("text.cInvoice.partPaid") }}</span
                >
                <span class="counter mr-2">{{ partPaidCount }}</span>
              </div>
              <div
                class="filter-item text-center"
                @click="changeStatus('all')"
                :class="[status === 'allStatus' ? 'activeFilter' : null]"
              >
                <span
                  class="mr-2"
                  :class="[status === 'allStatus' ? 'activeFilter' : null]"
                  >{{ $t("text.cInvoice.allInvoice") }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="position-relative">
          <ejs-grid
            v-show="!showLoader"
            ref="dataGrid"
            :created="refreshGrid"
            :allowPaging="false"
            :actionBegin="actionHandler"
            :allowSorting="true"
            :allowExcelExport="false"
            :allowPdfExport="false"
            :toolbarClick="toolbarClick"
            :allowTextWrap="true"
          >
            <e-columns>
              <e-column
                width="100"
                :template="invoiceTemplate"
                :headerText="$t('text.cInvoice.status')"
              ></e-column>
              <e-column
                width="150"
                :template="dateTemp"
                :headerText="$t('text.cInvoice.du')"
              ></e-column>
              <e-column
                width="200"
                field="invoiceDueDateFormatted"
                :headerText="$t('text.cInvoice.date')"
              ></e-column>
              <e-column
                width="200"
                field="customerName"
                :headerText="$t('text.cInvoice.customer')"
              ></e-column>
              <e-column
                width="200"
                field="amountDue"
                :headerText="`${$t('text.cInvoice.status')} (${
                  company ? company.currency : ''
                })`"
                textAlign="center"
              ></e-column>
              <e-column
                :template="list_of_invoices_templates"
                headerText="Action"
                width="200"
              ></e-column>
            </e-columns>
          </ejs-grid>
          <TableLoader :showLoader="showLoader" />
          <div class="mt-3" style="margin: 0 auto">
            <Paginator
              v-show="!showLoader"
              :total-pages="totalPages"
              :per-page="pageSize"
              :current-page="currentPage"
              @pagechanged="onPageChange"
              @getPageSize="getPageSize"
              :pageSize="pageSize"
            />
          </div>
        </div>
      </div>
    </AdminMasterLayout>
  </div>
</template>
<script>
import Vue from "vue";
import AdminMasterLayout from "@/views/Industrial/AdminMasterLayout.vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  groupAggregates,
} from "@syncfusion/ej2-vue-grids";
import Temp from "@/components/Templates/invoices";
import DateTemp from "@/components/Templates/dateTemp";
import Paginator from "@/components/Paginator.vue";
import invoiceTemp from "@/components/Templates/list_of_invoices_template.vue";
import VueMomentsAgo from "vue-moments-ago";

import Jquery from "jquery";
let $ = Jquery;

export default {
  title: "Invoice:: Epump Portal",
  components: {
    AdminMasterLayout,
    TableLoader,
    Paginator,
    VueMomentsAgo,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search],
  },
  data() {
    return {
      companyId: null,
      from: "",
      to: "",
      pageSize: 10,
      tableCount: 0,
      totalPages: 1,
      currentPage: 1,
      first: true,
      sortType: "",
      sortColumn: "",
      status: "allStatus",
      overDueCount: 0,
      sentCount: 0,
      partPaidCount: 0,
      paidCount: 0,
      allCount: 0,
      fromLabel: "From",
      invoiceTemplate: () => {
        return {
          template: Temp,
        };
      },
      toLabel: "To",
      isButtonDisabled: false,
      scheduleDateTime: null,
      showLoader: false,
      fromDate: "",
      toDate: "",
      invoiceNumber: "",
      overDueAmount: 0,
      dueInThirtyDays: 0,
      averageTimeToGetPaid: 0,
      dateRetrieved: "",
      company: null,
      list_of_invoices_templates: function () {
        return {
          template: invoiceTemp,
        };
      },
      dateTemp: function () {
        return {
          template: DateTemp,
        };
      },
    };
  },
  mounted() {
    Array.from(document.getElementsByTagName("input")).forEach((input) => {
      if (!Array.from(input.classList).includes("form-control")) {
        input.classList.add("form-control");
      }
    });
    // console.log(this.$route.name);
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if (this.$route.query.companyID) {
      this.getInvoices();
      this.getInvoiceSummary();
    }
  },
  watch: {
    fromDate: function (newDate) {
      if (newDate) {
        this.currentPage = 1;
        this.getInvoices();
      }
    },
    company(company) {
      if (company !== null) {
        this.getInvoices();
        this.getInvoiceSummary();
      }
    },

    toDate: function (newDate) {
      if (newDate) {
        this.currentPage = 1;
        this.getInvoices();
      }
    },
    invoiceNumber: function (newNumber) {
      this.currentPage = 1;
      this.getInvoices();
    },
    status: function (newStatus) {
      this.currentPage = 1;
      this.getInvoices();
    },
  },
  methods: {
    actionHandler: function (args) {
      if (args.requestType == "sorting") {
        if (args.direction) {
          this.sortType = args.direction;
          this.sortColumn = args.columnName;
        } else {
          this.sortType = "";
          this.sortColumn = "";
        }

        this.getInvoices();
      }
    },
    getPageSize(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.totalPages = Math.ceil(this.tableCount / pageSize);
      this.getInvoices();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.getInvoices();
    },
    getInvoiceSummary() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Invoices/invoices-summary?id=${
            this.$route.query.companyID
              ? this.$route.query.companyID
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((res) => {
          this.overDueAmount = this.convertThousand(res.data.overDue);
          this.dueInThirtyDays = this.convertThousand(res.data.dueInThirtyDays);
          this.averageTimeToGetPaid = res.data.averageTimeToGetPaid;
          this.dateRetrieved = res.data.dateRetrieved;
          this.overDueCount = res.data.overDueCount;
          this.partPaidCount = res.data.partPaidCount;
          this.paidCount = res.data.paidCount;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getInvoices() {
      this.first ? (this.showLoader = true) : (this.showLoader = false);
      this.first = false;
      const status = this.status == "allStatus" ? "" : parseInt(this.status);
      const applyPaging = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Invoices?PageIndex=${
            this.currentPage
          }&PageSize=${this.pageSize}&Sort=${this.sortColumn}&StartDate=${
            this.fromDate
          }&EndDate=${
            this.toDate
          }&Status=${status}&ApplyPaging=${applyPaging}&Customer=${
            this.$route.query.companyID
              ? this.$route.query.companyID
              : this.company.id
          }&InvoiceNumber=${this.invoiceNumber}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.totalPages = Math.ceil(res.data.count / this.pageSize);
          this.tableCount = res.data.count;

          res.data.data.sort((a, b) => {
            return a.invoiceDueDate > b.invoiceDueDate
              ? 1
              : b.invoiceDueDate > a.invoiceDueDate
              ? -1
              : 0;
          });

          res.data.data.forEach((cur, index) => {
            cur.amountDue = this.convertThousand(cur.amountDue);
            cur.status =
              cur.status == 0
                ? "Draft"
                : cur.status == 1
                ? "Pending"
                : cur.status == 2
                ? "Unsent"
                : cur.status == 3
                ? "OverDue"
                : cur.status == 4
                ? "Paid"
                : cur.status == 5
                ? "PartPaid"
                : "Not available";
            cur.invoiceDueDateFormatted = this.$moment(
              cur.invoiceDueDate
            ).format("DD-MM-YYYY");
            cur.index = index;
          });

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: res.data.data,
          });
          this.refreshGrid();
          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    timeSince(date) {
      let seconds = Math.floor((new Date() - date) / 1000);
      const value = seconds < 0 ? "from now" : "ago";
      seconds = Math.abs(seconds);

      var interval = seconds / 31536000;

      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " year " : " years ") +
          value
        );
      }
      interval = seconds / 2592000;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " month " : " months ") +
          value
        );
      }
      interval = seconds / 86400;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " day " : " days ") +
          value
        );
      }
      interval = seconds / 3600;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " hour " : " hours ") +
          value
        );
      }
      interval = seconds / 60;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) == 1 ? " minute " : " minutes ") +
          value
        );
      }
      return (
        Math.floor(seconds) +
        (Math.floor(interval) == 1 ? " second " : " seconds ") +
        value
      );
    },
    changeStatus(status) {
      if (status === "overdue") {
        this.status = "3";
      }
      if (status === "paid") {
        this.status = "4";
      }
      if (status === "partPaid") {
        this.status = "5";
      }
      if (status === "all") {
        this.status = "allStatus";
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "invoices.pdf",
          };
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
